/* eslint-disable no-unused-vars */
import React,{useState, useEffect} from "react";
import jwt from 'jsonwebtoken';
import {privateToken} from '../ExamTest/getExam';
import Footer from "../components/footer";
import {addCart} from '../../redux/actions/cart';
import {useDispatch, useSelector} from 'react-redux';
import dbRef from "../../config/dbRef";
import { getAuth } from "firebase/auth";
import {db} from '../../config/firebase'
import { doc, addDoc, getDoc, collection } from "firebase/firestore";
import { Bar, OnLoad } from "../components/onload";
import { getUser } from '../../redux/actions/user';
import {auth} from '../../config/firebase';
import { Contactanos } from "../components/uiComponents";
import {Link} from 'react-router-dom';
import ReactGa from 'react-ga';
import { FaShareAlt, FaCheck, FaLayerGroup, FaRegCalendarAlt, FaMapMarkerAlt } from 'react-icons/fa';

const AREA_LABELS = {
  juridico: 'Jurídico',
  medico: 'Medicina',
  academico: 'Académico',
  policial: 'Policial',
  teacher: 'ESFM',
};

const STATUS_META = {
  activo: { badge: 'bg-primary bg-opacity-10 text-primary', label: 'Vigente' },
  proximo: { badge: 'bg-yellow-100 text-yellow-700', label: 'Próximamente' },
  pasado: { badge: 'bg-gray-100 text-gray-500', label: 'Pasada' },
};

const getQueryParam = (search, key) => {
  if (!search) return '';
  return new URLSearchParams(search).get(key) || '';
};

const extractExamFromLocation = (location) => {
  const payload = location.data;
  const type = location.type || getQueryParam(location.search, 'type') || '';
  if (!payload) {
    return { data: null, id: getQueryParam(location.search, 'idExam'), type };
  }
  if (payload.nombre) {
    return {
      data: payload,
      id: payload.id || payload.idExamen || getQueryParam(location.search, 'idExam'),
      type,
    };
  }
  if (payload.data && payload.data.nombre) {
    return {
      data: payload.data,
      id: payload.id || payload.data.idExamen || payload.data.id || getQueryParam(location.search, 'idExam'),
      type,
    };
  }
  return { data: null, id: getQueryParam(location.search, 'idExam'), type };
};

const Details = (props) => {
  const user = useSelector(state => state.user);
  const dispatch = useDispatch();
  const [id,setId]= useState('');
  const [data ,setData]= useState();
  const [examType, setExamType] = useState('');
  const [textBtn,setTextBtn]= useState("Adquirir Plan");
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);
  const [copied, setCopied] = useState(false);

  const btnAnalytics = (btn) => {
    ReactGa.event({
      category: 'Button-details',
      action: 'Click button :'+btn,
    })
  }

  useEffect(() => {
    const bar = document.getElementById('bar');
    if (bar) bar.style.display = 'block';
  }, []);

  useEffect(() => {
    let cancelled = false;

    const loadExam = async () => {
      setLoading(true);
      setNotFound(false);

      const extracted = extractExamFromLocation(props.location);
      const idFromQuery = getQueryParam(props.location.search, 'idExam');
      const typeFromQuery = getQueryParam(props.location.search, 'type');
      const nextType = extracted.type || typeFromQuery || '';
      if (!cancelled) setExamType(nextType);

      if (extracted.data) {
        const examId = extracted.id || idFromQuery;
        if (!cancelled) {
          setData(extracted.data);
          setId(examId);
          setLoading(false);
        }
        if (examId && idFromQuery !== examId) {
          const params = new URLSearchParams();
          params.set('idExam', examId);
          if (nextType) params.set('type', nextType);
          props.history.replace({
            pathname: '/Details',
            search: `?${params.toString()}`,
            data: props.location.data,
            type: nextType,
          });
        }
        return;
      }

      if (idFromQuery) {
        try {
          const snap = await getDoc(doc(db, dbRef.exam, idFromQuery));
          if (cancelled) return;
          if (snap.exists()) {
            setData(snap.data());
            setId(snap.id);
          } else {
            setNotFound(true);
          }
        } catch (error) {
          if (!cancelled) setNotFound(true);
        } finally {
          if (!cancelled) setLoading(false);
        }
        return;
      }

      if (!cancelled) {
        setLoading(false);
        props.history.push('/convocatoria');
      }
    };

    loadExam();
    return () => { cancelled = true; };
  }, [props.location.search, props.location.data, props.history, props.location.type]);

  const shareUrl = id
    ? `${window.location.origin}/Details?idExam=${id}${examType ? `&type=${examType}` : ''}`
    : '';

  const handleShare = async () => {
    if (!shareUrl) return;
    btnAnalytics('Compartir');
    if (navigator.share) {
      try {
        await navigator.share({
          title: data && data.nombre ? data.nombre : 'Apriori',
          text: data && data.nombre ? `Convocatoria: ${data.nombre}` : 'Mira esta convocatoria en Apriori',
          url: shareUrl,
        });
        return;
      } catch (error) {
        if (error && error.name === 'AbortError') return;
      }
    }
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(shareUrl);
      } else {
        window.prompt('Copia el enlace', shareUrl);
      }
      setCopied(true);
      setTimeout(() => setCopied(false), 2200);
    } catch (error) {
      window.prompt('Copia el enlace', shareUrl);
    }
  };

  const anidirExamen = async (paramId) => {
    let dataMaterias=[];
    data.materias.map(materia => {
      dataMaterias.push(materia.nombre);
    })
    
    const currentAuth = getAuth();
    const currentUser = currentAuth.currentUser;
    
    const cuenta = doc(db, dbRef.user + '/' + currentUser.uid);

    if(examType==='teacher' || (props.location && props.location.type==='teacher')){
      const newExamFinal = {
        idExamen: paramId,
        fechaRegistro: new Date().toISOString(),
        plan:'Pendiente',
        tipo : 'PFinal',
        nombre : data.nombre,
        fechaExamen: data.fecha,
        materias :dataMaterias,
        estado: 'pendiente',
        cantidadPreguntas: 40,
        intentos: 10,
        type: 'teacher'
      }
      await addDoc(collection(cuenta, 'cuenta'), newExamFinal);
    }else{
      const newExamFinal = {
        idExamen: paramId,
        fechaRegistro: new Date().toISOString(),
        plan:'Pendiente',
        tipo : 'PFinal',
        nombre : data.nombre,
        fechaExamen: data.fecha,
        materias :dataMaterias,
        estado: 'pendiente',
        cantidadPreguntas: `${data.cantidadPreguntas?data.cantidadPreguntas:0}`,
        intentos: `${data.intentos?data.intentos:0}`,
      }
      const newExamPrueba = {
        idExamen: paramId,
        fechaRegistro: new Date().toISOString(),
        plan:'Pendiente',
        tipo : 'PPrac',
        nombre : data.nombre,
        fechaExamen: data.fecha,
        materias :dataMaterias,
        estado: 'pendiente',
        cantidadPreguntas: `${data.cantidadPreguntas?data.cantidadPreguntas:0}`,
        intentos: `${data.intentos?data.intentos:0}`,
      }
      await addDoc(collection(cuenta, 'cuenta'), newExamFinal);
      await addDoc(collection(cuenta, 'cuenta'), newExamPrueba);
    }
    alert('Examen agregado');
  };

  const verificarExamen = (paramId) => {
    if (!user || !user.cuenta) return true;
    return !user.cuenta.some((examen) => examen.idExamen === paramId);
  }

  const examtestPath = data && data.materias
    ? `/examtest/${jwt.sign(JSON.stringify(data.materias), privateToken)}`
    : '/convocatoria';

  const status = data && STATUS_META[data.estado] ? STATUS_META[data.estado] : STATUS_META.activo;

    return (
        <>
        {loading ? (
          <div className="min-h-screen bg-gray-100 flex flex-col items-center justify-center">
            <OnLoad color="#e84529" />
            <p className="text-gray-500 mt-4">Cargando convocatoria...</p>
          </div>
        ) : notFound ? (
          <div className="min-h-screen bg-gray-100 flex flex-col items-center justify-center px-6">
            <p className="text-2xl font-bold text-fondo text-center">No encontramos este examen</p>
            <p className="text-gray-600 mt-2 text-center">El enlace puede estar incompleto o la convocatoria ya no está disponible.</p>
            <Link className="bg-primary text-white font-semibold py-3 px-6 rounded-full mt-6" to="/convocatoria">
              Ver convocatorias
            </Link>
          </div>
        ) : data ? (
          <>
          <div className="bg-gray-100 mt-20 py-12 px-6 md:px-10">
            <div className="landing-wrap">
              <p className="text-sm text-gray-500 text-center md:text-left">
                <Link to="/" className="hover:text-primary">Inicio</Link>
                {' / '}
                <Link to="/convocatoria" className="hover:text-primary">Convocatorias</Link>
                {' / '}
                <span className="text-fondo">{data.nombre}</span>
              </p>
              {data.estado && (
                <span className={`inline-block text-xs font-semibold uppercase tracking-wide rounded-full px-3 py-1 mt-4 ${status.badge}`}>
                  {status.label}
                </span>
              )}
              <h1 className="text-3xl md:text-5xl font-bold text-fondo mt-3">{data.nombre}</h1>
              <p className="text-base md:text-xl text-gray-600 mt-4 max-w-3xl">
                Te damos la posibilidad de probar nuestra plataforma de forma gratuita.
              </p>
              <div className="flex flex-row flex-wrap items-center mt-6">
                <Link
                  onClick={()=>btnAnalytics('Prueba Gratis')}
                  className="bg-primary text-white font-semibold py-3 px-6 rounded-full mr-3 mt-2 hover:bg-fondo"
                  to={examtestPath}
                >
                  Prueba gratis ahora
                </Link>
                {id && (
                  <button
                    type="button"
                    onClick={handleShare}
                    className="bg-white text-fondo font-semibold py-3 px-6 rounded-full mt-2 border border-gray-200 hover:border-primary flex items-center"
                  >
                    {copied ? <FaCheck className="text-primary mr-2" /> : <FaShareAlt className="text-primary mr-2" />}
                    {copied ? 'Enlace copiado' : 'Compartir'}
                  </button>
                )}
              </div>
            </div>
          </div>
          
          <div className="w-full bg-white py-10 px-6 md:px-10">
            <div className="landing-wrap flex flex-col md:flex-row">
            <div className="w-full md:w-1/2 md:pr-10">
              <p className="text-sm font-bold text-primary uppercase tracking-widest">Datos generales</p>
              <p className="text-2xl md:text-3xl font-bold text-fondo mt-2">{data.nombre}</p>
              <p className="text-sm md:text-base text-gray-600 mt-3 leading-relaxed">
                {data.descripcion}
              </p>
              <div className="flex flex-row flex-wrap mt-5 text-sm text-gray-600">
                {data.fecha && (
                  <div className="flex items-center mr-4 mb-2">
                    <FaRegCalendarAlt className="text-primary mr-2"/>
                    <span>{data.fecha}</span>
                  </div>
                )}
                {data.area && (
                  <div className="flex items-center mr-4 mb-2">
                    <FaMapMarkerAlt className="text-primary mr-2"/>
                    <span>{AREA_LABELS[data.area] || data.area}</span>
                  </div>
                )}
                {data.materias && (
                  <div className="flex items-center mb-2">
                    <FaLayerGroup className="text-primary mr-2"/>
                    <span>{data.materias.length} materias</span>
                  </div>
                )}
              </div>
              {data.materias && data.materias.length > 0 && (
                <div className="flex flex-row flex-wrap mt-3">
                  {data.materias.map((materia, index) => (
                    <span key={index} className="text-xs bg-gray-100 text-fondo rounded-full px-3 py-1 mr-2 mb-2">
                      {materia.nombre || materia}
                    </span>
                  ))}
                </div>
              )}
              {data.recursos && data.recursos.length > 0 && (
                <>
                  <p className="text-sm font-bold text-primary uppercase tracking-widest mt-6">Recursos</p>
                  <ul className="mt-2">
                    {data.recursos.map((item,index)=>(
                      <li key={index} className="text-sm mt-2">
                        <a className="text-primary hover:underline" href={item.url} target="_blank" rel="noopener noreferrer">{item.nombre}</a>
                      </li>
                    ))}
                  </ul>
                </>
              )}
              <div className="w-full flex flex-row flex-wrap items-center mt-6">
                <Link
                  onClick={()=>btnAnalytics('Prueba Gratis')}
                  className="bg-white text-primary font-semibold py-3 px-5 mr-3 mt-2 rounded-full border-2 border-primary hover:bg-primary hover:text-white"
                  to={examtestPath}
                >
                  Prueba gratis
                </Link>
                
                {
                data.estado==='activo'?
                
                <button className="bg-primary text-white font-semibold py-3 px-5 rounded-full mt-2 hover:bg-fondo"
                onClick={()=>{
                  btnAnalytics('adquirir plan');
                  if(textBtn === 'Adquirir Plan'){
                    setTextBtn("Agregado");
                    dispatch(addCart({
                      id:id,
                    })).then(() => {
                        if(auth.currentUser){
                          if(verificarExamen(id)){
                            anidirExamen(id).then(()=>{
                              const userID = auth.currentUser.uid;
                              dispatch(getUser(userID));
                            }).then(()=>{
                              props.history.push('/profile'); 
                            });
                          }else{
                            alert('Esta Prueba ya existe en su perfil');
                            props.history.push('/convocatoria');
                          }
                        }else{
                          props.history.push('/login');
                        }
                    });
                  }
                }}
              >
                {textBtn === 'Adquirir Plan'?textBtn:<Bar color={'white'}/>}
                </button>
                :
                <Contactanos type='fill' texto='Contáctanos'/>
              }
              </div>
            </div>
            <div className="w-full md:w-1/2 mt-10 md:mt-0 bg-gray-100 rounded-2xl p-6 md:p-8">
              <p className="text-sm font-bold text-primary uppercase tracking-widest">Documentación mínima habilitante</p>
              {data.documentacion && data.documentacion.length > 0 ? (
                <ul className="mt-4">
                  {data.documentacion.map((item,index)=>(
                    <li key={index} className="text-sm md:text-base text-fondo mt-3 pl-3 border-l-2 border-primary">
                      {item}
                    </li>
                  ))}
                </ul>
              ) : (
                <p className="text-gray-500 mt-4 text-sm">No hay documentación publicada para esta convocatoria.</p>
              )}
            </div>
            </div>
          </div>
          </>
        ) : null}
        <Footer/>
        
        </>
    );
}

export default Details;
